export function getTenant() {
    return new Promise((resolve) =>
        setTimeout(() =>
            resolve(
                fetch(process.env.REACT_APP_API_URL + '/requestApi/getTenant', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                        'access-control-allow-origin': '*',
                        'Authorization': process.env.REACT_APP_AUTHORIZATION_KEY
                    }, 
                    credentials: process.env.NODE_ENV !== "production" ? "include" : "same-origin",
                })
                    .then(res => res.json())
                    .then((data) => {
                        return data;
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    })
            )
        ), 0)
}

export function checkSession() {
    return new Promise((resolve) =>
        setTimeout(() =>
            resolve(
                fetch(process.env.REACT_APP_API_URL + '/SessionApi/CheckSession', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                        'access-control-allow-origin': '*',
                        'Authorization': process.env.REACT_APP_AUTHORIZATION_KEY
                    },
                    credentials: process.env.NODE_ENV !== "production" ? "include" : "same-origin",
                })
                    .then(res => res.json())
                    .then((data) => {
                        return data;
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    })
            )
        ), 0)
}

export function GetOrder(data) {
    return new Promise((resolve) =>
        setTimeout(() =>
            resolve(
                fetch(process.env.REACT_APP_API_URL + '/RequestApi/GetOrder', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                        'access-control-allow-origin': '*',
                        'Authorization': process.env.REACT_APP_AUTHORIZATION_KEY
                    },
                    credentials: process.env.NODE_ENV !== "production" ? "include" : "same-origin",
                    body: JSON.stringify(data)
                }).then(res=>res.json())
                    // .then(async res => {
                    //     // Check if the response has a body
                    //     const contentType = res.headers.get('content-type');
                    //     if (!contentType || !contentType.includes('application/json')) {
                    //         // No JSON response, return null or do something else
                    //         return {
                    //             resStatusCode: res.status,
                    //         };
                    //     } 
                    //     return await res.json()
                    // })
                    .then((data) => {
                        return data;
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    })
            )
        ), 0)
}
